import * as React from 'react';
import { connect } from 'react-redux';
import {DASHBOARD, LOGIN} from '../../routes/routes';
import {signInAnonRedirect, SignInWithOTPToken} from "../../actions/authActions";
import {Button, Image} from "react-bootstrap";
import KPInputTextArea from "../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea";
import {setExternalData} from "../../actions/externalActions";
import {navigateTo} from "../../actions/navigationActions";

class MobileAutoLogin extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            OTP: "",
            redirectUrl: DASHBOARD,
            buttonDisabled: true,
        };
        this.updateOtp = this.updateOtp.bind(this)
        this.verifyRedirectOTP = this.verifyRedirectOTP.bind(this)
    }

    async componentDidMount() {
        let type = this.props.match.params.type?.toString();
        let identifier = this.props.match.params.identifier?.toString();
        let isUser = type != "salelogin";
        await this.props.dispatchAction(setExternalData({ redirectType:type,redirectIdentifier: identifier }));
        if (isUser){
            await this.props.dispatchAction(signInAnonRedirect());
        }
        else{
            await this.props.dispatchAction(navigateTo(LOGIN));
        }
    }

    verifyRedirectOTP() {
        this.props.dispatchAction(SignInWithOTPToken(this.state.OTP, this.state.redirectUrl));
    }

    async updateOtp(otp) {
        let invalid = true;
        if (otp.length == 6)
            invalid = false;
        this.setState({OTP: otp,buttonDisabled: invalid});
    }

    public render() {
        return (
            <div className="pt-lg-5 p-lg-05 logged-out container">
                <div className="text-center">
                    <Image src="./Images/icon-red-warning.svg" className="img-fluid" alt="warningImage" />
                    <h3 className="mt-4">One-time PIN (OTP)</h3>
                </div>
                <div className='text-center'>
                    <div>
                        We’ve sent you an email/SMS with an OTP. Please check if you’ve received it, and type it here:
                    </div>
                    <br />
                    <KPInputTextArea
                        id="OTPVerificationInput"
                        name="OTP"
                        type="text"
                        className="mb-4"
                        label="OTP"
                        showLabelAfterSelection={true}
                        value={this.state.OTP}
                        notice={false}
                        noticeType="error"
                        noticeMessage={false}
                        successTick={false}
                        required={true}
                        readOnly={false}
                        autoFocus={false}
                        minLength={6}
                        maxLength={6}
                        disabled={false}
                        form="mainform"
                        handleChange={(e) => this.updateOtp(e.target.value)}
                    />
                </div>
                    <div className="text-center mt-4">
                        <Button className="w-100 btn btn-solid-green btnResponsive" onClick={() => {
                            this.setState({buttonDisabled: true});
                            this.verifyRedirectOTP();
                        }} disabled={(this.state.buttonDisabled)}>Confirm</Button>
                    </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileAutoLogin);